var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{hide: !_vm.isShow}},[_c('div',{staticClass:"van-overlay",staticStyle:{"z-index":"2001"},on:{"click":_vm.handleCancel}}),_c('van-picker',{ref:"vpicker",staticClass:"main-con",attrs:{"show-toolbar":"","title":"标题","columns":_vm.columns},on:{"cancel":_vm.handleCancel,"confirm":_vm.selectArea}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }